// extracted by mini-css-extract-plugin
export var box = "_5p-0";
export var check = "_5p-1";
export var checkboxButton = "_5p-6";
export var checkboxGroup = "_5p-5";
export var disabled = "_5p-7";
export var ghost = "_5p-9";
export var input = "_5p-2";
export var label = "_5p-4";
export var normal = "_5p-8";
export var uncheck = "_5p-3";